<app-header></app-header>


<div class="container">
  <div class="row justify-content-center">

    <!--    <nav class="d-none d-xl-block col-xl-2 fixed-top mt-7">-->
    <!--      <ul class="nav flex-column">-->
    <!--        <li class="nav-item">-->
    <!--          <a class="nav-link" [href]="this.location.path() + '#informations_sur_la_compagnie'">Informations sur la compagnie</a>-->
  <!--        </li>-->
  <!--        <li class="nav-item">-->
  <!--          <a class="nav-link" href="#informations_sur_le_vehicule">Informations sur le véhicule</a>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </nav>-->

<div class="col-12">
  <form class="tab-content py-6">
    <div class="row">
      <div class="col-12">
        <h1>Comparaison achat véhicule vs location</h1>
      </div>
    </div>

    <hr class="mt-2 mb-5">

    <h2 id="informations_sur_la_compagnie">Informations sur la compagnie</h2>

    <div class="row">
      <div class="col-12 col-lg-6">

        <div class="form-group">
          <div class="custom-control custom-switch">
            <input [(ngModel)]="calculAchatCorporatifAvecAvantage.societeInscriteAuxTaxes"
              class="custom-control-input" id="societeInscriteAuxTaxes"
              name="societeInscriteAuxTaxes"
              type="checkbox">
            <label class="custom-control-label" for="societeInscriteAuxTaxes">Est-ce que la société est inscrite aux
            taxes?</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6">

        <div class="form-group">
          <!-- Label -->
          <h3>
            Comment la société paie les avantages imposables reliés au véhicule?
          </h3>

          <!-- Input -->
          <div class="form-check mb-2">
            <input [(ngModel)]="calculAchatCorporatifAvecAvantage.methodeDePaiementAvantagesImposables"
              class="form-check-input" id="methodeDePaiementAvantagesImposables_dividende"
              name="methodeDePaiementAvantagesImposables" type="radio"
              value="dividende">
            <label class="form-check-label" for="methodeDePaiementAvantagesImposables_dividende">
              En versant des dividenses à l'employé?
            </label>
          </div>
          <div class="form-check mb-2">
            <input [(ngModel)]="calculAchatCorporatifAvecAvantage.methodeDePaiementAvantagesImposables"
              class="form-check-input" id="methodeDePaiementAvantagesImposables_salaire"
              name="methodeDePaiementAvantagesImposables" type="radio"
              value="salaire">
            <label class="form-check-label" for="methodeDePaiementAvantagesImposables_salaire">
              En versant un salaire additionnel à l'employé?
            </label>
          </div>

        </div>
      </div>
    </div>

    @if (calculAchatCorporatifAvecAvantage.methodeDePaiementAvantagesImposables === 'salaire') {
      <div class="row">
        <div class="col-12">
          <h3>Informations additionnelles lors que les avantages sont payés en salaire</h3>
          <p>Lorsque les avantages sont payés en salaire, les informations suivantes sont requises pour déterminer
          avec précision</p>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="mb-1">Quelle est la masse salariale de l'entreprise?
              <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                placement="auto"
                popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                type="button"><i
              class="far fa-info-circle"></i> Info
            </button>
          </label>
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <input [(ngModel)]="calculAchatCorporatifAvecAvantage.salaire.masseSalarialeEntreprise"
                  aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
                  name="masseSalariale"
                  step="1"
                  type="number">
                <div class="input-group-append">
                  <span class="input-group-text">.00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <div class="custom-control custom-switch">
            <input [(ngModel)]="calculAchatCorporatifAvecAvantage.salaire.societeEmployeurPublic"
              class="custom-control-input" id="employeurSecteurPublic"
              name="employeurSecteurPublic"
              type="checkbox">
            <label class="custom-control-label" for="employeurSecteurPublic">Est-ce que la société est un employeur
            du secteur public?</label>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <div class="custom-control custom-switch">
            <input [(ngModel)]="calculAchatCorporatifAvecAvantage.salaire.cinquantePourcentSecteurPrimaireOuManufacturier"
              class="custom-control-input"
              id="cinquantePourcentMasseSalarialeTotaleActivitesSecteurPrimaireOuManufacturier"
              name="cinquantePourcentMasseSalarialeTotaleActivitesSecteurPrimaireOuManufacturier"
              type="checkbox">
            <label class="custom-control-label"
              for="cinquantePourcentMasseSalarialeTotaleActivitesSecteurPrimaireOuManufacturier">Est-ce que
            plus de 50% de la MST est attribubale à des activités du secteur primaire ou manufacturier?</label>
          </div>
        </div>
      </div>
    </div>
  }

  <hr class="mt-2 mb-5">

  <h2 id="informations_sur_employe">Informations sur l'employé</h2>

  <div class="row">
    <div class="col-12 col-lg-6">

      <div class="form-group">
        <div class="custom-control custom-switch">
          <input [(ngModel)]="calculAchatCorporatifAvecAvantage.salarieCotisationAssuranceEmploi"
            class="custom-control-input" id="salarieCotisationAssuranceEmploi"
            name="salarieCotisationAssuranceEmploi"
            type="checkbox">
          <label class="custom-control-label" for="societeInscriteAuxTaxes">Est-ce que le salarié paie des
          cotisations d'assurance-emploi ?</label>
        </div>
      </div>
    </div>
  </div>

  <hr class="mt-2 mb-5">

  <h2 id="informations_sur_le_vehicule">Informations sur le véhicule</h2>

  <div class="row">
    <div class="col-12">
      <div class="form-group">

        <label class="mb-1">Mois à partir duquel le véhicule est mis à la disposition de l'employé?</label>
        <div class="row">
          <div class="col-12 col-lg-4">
            <select [(ngModel)]="calculAchatCorporatifAvecAvantage.moisVehiculeMisADispositionPourEmployee"
              class="custom-select" data-toggle="select"
              name="moisVehiculeMisADispositionPourEmployee">
              <option [ngValue]="1">Janvier</option>
              <option [ngValue]="2">Février</option>
              <option [ngValue]="3">Mars</option>
              <option [ngValue]="4">Avril</option>
              <option [ngValue]="5">Mai</option>
              <option [ngValue]="6">Juin</option>
              <option [ngValue]="7">Juillet</option>
              <option [ngValue]="8">Août</option>
              <option [ngValue]="9">Septembre</option>
              <option [ngValue]="10">Octobre</option>
              <option [ngValue]="11">Novembre</option>
              <option [ngValue]="12">Décembre</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="form-group">

        <!-- Label -->
        <h3>
          Choississez la situation qui s'applique au véhicule
        </h3>

        <!-- Input -->
        <div class="form-check mb-2">
          <input [(ngModel)]="calculAchatCorporatifAvecAvantage.situationVehicule" class="form-check-input"
            id="situationVehicule_fourgonnette_trois_places_ou_moins_plus_de_50"
            name="situationVehicule"
            type="radio"
            value="fourgonnetteTroisPlacesOuMoinsUtilisePlusDe50Pourcent">
          <label class="form-check-label" for="situationVehicule_fourgonnette_trois_places_ou_moins_plus_de_50">
            Il s'agit d'une fourgonnette ou camionnette de trois places et moins, qui est utilisé à plus de 50%
            par la compagnie
          </label>
        </div>
        <div class="form-check mb-2">
          <input [(ngModel)]="calculAchatCorporatifAvecAvantage.situationVehicule" class="form-check-input"
            id="situationVehicule_fourgonnette90PourcentTransportMarchandiseOuPassager"
            name="situationVehicule"
            type="radio"
            value="fourgonnette90PourcentTransportMarchandiseOuPassager">
          <label class="form-check-label"
            for="situationVehicule_fourgonnette90PourcentTransportMarchandiseOuPassager">
            Il s'agit d'une fourgonnette ou camionnette servant en totalité ou presque (90 % et plus) à
            transporter des marchandises ou des passagers
          </label>
        </div>
        <div class="form-check">
          <input [(ngModel)]="calculAchatCorporatifAvecAvantage.situationVehicule" class="form-check-input"
            id="situationVehicule_aucune" name="situationVehicule"
            type="radio" value="aucune">
          <label class="form-check-label" for="situationVehicule_aucune">
            Aucune de ces situations
          </label>
        </div>

      </div>
    </div>
  </div>

  <hr class="mt-2 mb-5">

  <h2>Scénarios à considérer</h2>

  <div>
    <p>Il y a trois scénarios différents qui seront considéré afin de déterminer, selon votre situation fiscale,
    le scénario</p>
    <ol>
      <li><strong>Location d'un véhicule sur toute la durée.</strong>
      <p>Pour ce scénario, nous considérons que le véhicule est seulement loué et jamais racheté. Il est
        possible d'inclure un deuxième à bail à partir d'un certain nombre de mois et de configurer la nouvelle
      mensualité.</p></li>
      <li><strong>Achat d'un véhicule</strong>
      <p>Pour ce scénario, nous considérons que le véhicule est acheté et est conservé pour toute la durée de
      l'analyse.</p></li>
      <li><strong>Location d'un véhicule puis rachat du véhicule</strong>
      <p>Pour ce scénario, nous considérons que le véhicule est seulement loué et par la suite, il est racheté.
        On considère que pour la première portion de l'analyse, le véhicule est loué et qu'il est ensuite acheté
      et utilisé jusqu'à la fin de l'analyse.</p></li>
    </ol>
  </div>
  <!-- BEGIN: SCÉNARIO LOCATION -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div (click)="toggleScenarioCollapse('location')" class="card-header card-header-collapsible">
          <div>
            <button class="btn btn-link d-inline ml-0 pl-0">
              @if (isScenarioCollapsed('location') === false) {
                <span>
                  <i class="fas fa-chevron-down"></i>
                </span>
              }
              @if (isScenarioCollapsed('location')) {
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              }
            </button>

            <h4 class="card-header-title mr-auto d-inline">
              Location d'un véhicule sur toute la durée
            </h4>
          </div>

        </div>

        <div [ngClass]="getScenarioStyle('location')" class="card-body">
          <p class="description">Pour ce scénario, il est possible d'inclure une deuxième location à partir d'un
          certain nombre de mois</p>

          <div class="row">
            <div class="col-12 col-lg-6">

              <div class="form-group">

                <label class="mb-1">Mensualité de la location
                  <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                    placement="auto"
                    popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                    type="button"><i
                  class="far fa-info-circle"></i> Info
                </button>
              </label>

              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                    <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioLocation.mensualitePremiereLocation"
                      aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
                      name="mensualitePremiereLocation" step="1"
                      type="number">
                    <div class="input-group-append">
                      <span class="input-group-text">.00</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr>
          <h3>Deuxième location</h3>
          <div class="row">
            <div class="col-12 col-lg-12">

              <div class="form-group">
                <div class="custom-control custom-switch">
                  <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioLocation.deuxiemeLocationDansLaPeriode"
                    class="custom-control-input" id="deuxiemeLocationDansLaPeriode"
                    name="deuxiemeLocationDansLaPeriode"
                    type="checkbox">
                  <label class="custom-control-label" for="deuxiemeLocationDansLaPeriode">Voulez-vous inclure une
                  deuxième location dans l'analyse?</label>
                </div>
              </div>
            </div>
          </div>

          @if (calculAchatCorporatifAvecAvantage.scenarioLocation.deuxiemeLocationDansLaPeriode) {
            <div
              class="row">
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label class="mb-1">Après combien de mois se termine la première location?
                    <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                      placement="auto"
                      popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                      type="button"><i
                    class="far fa-info-circle"></i> Info
                  </button>
                </label>
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="input-group">
                      <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioLocation.nombreDeMoisPremiereLocation"
                        aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
                        name="nombreDeMoisPremiereLocation"
                        step="1"
                        type="number">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="mb-1">Mensualité de la deuxième location
                  <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                    placement="auto"
                    popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                    type="button"><i
                  class="far fa-info-circle"></i> Info
                </button>
              </label>
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                    <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioLocation.mensualitePourDeuxiemeLocation"
                      aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
                      name="mensualitePourDeuxiemeLocation" step="1"
                      type="number">
                    <div class="input-group-append">
                      <span class="input-group-text">.00</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }


    </div>
  </div>
</div>
</div>
<!-- END: SCÉNARIO LOCATION -->

<!-- BEGIN: SCÉNARIO ACHAT -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div (click)="toggleScenarioCollapse('achat')" class="card-header card-header-collapsible">
        <div>
          <button class="btn btn-link d-inline ml-0 pl-0">
            @if (isScenarioCollapsed('achat') === false) {
              <span>
                <i class="fas fa-chevron-down"></i>
              </span>
            }
            @if (isScenarioCollapsed('achat')) {
              <span>
                <i class="fas fa-chevron-right"></i>
              </span>
            }
          </button>

          <h4 class="card-header-title mr-auto d-inline">
            Achat d'un véhicule
          </h4>
        </div>
      </div>

      <div [ngClass]="getScenarioStyle('achat')" class="card-body">
        <p class="description">Pour ce scénario, nous considérons que le véhicule est acheté et est conservé
          pour toute la durée de
        l'analyse.</p>

        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group">

              <label class="mb-1">Quel est le coût d'achat du véhicule (sans taxes)
                <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                  placement="auto"
                  popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                  type="button"><i
                class="far fa-info-circle"></i> Info
              </button>
            </label>

            <div class="row">
              <div class="col-12 col-lg-6">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioAchat.coutAchatVehiculeSansTaxes"
                    aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
                    name="cout_achat_vehicule_sans_taxes"
                    step="1"
                    type="number">
                  <div class="input-group-append">
                    <span class="input-group-text">.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- BEGIN: MONTANT DES MENSUALITÉS -->
        <div class="col-12 col-lg-6">

          <div class="form-group">

            <label class="mb-1">Montant des mensualités
              <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                placement="auto"
                popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                type="button"><i
              class="far fa-info-circle"></i> Info
            </button>
          </label>

          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioAchat.montantDesMensualites"
                  aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
                  name="montant_des_mensualites"
                  step="1"
                  type="number">
                <div class="input-group-append">
                  <span class="input-group-text">.00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: MONTANT DES MENSUALITÉS -->

      <!-- BEGIN: TAUX D'INTÉRÊT ANNUEL -->
      <div class="col-12 col-lg-6">

        <div class="form-group">

          <label class="mb-1">Quel est le taux d'intérêt annuel?
            <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
              placement="auto"
              popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
              type="button"><i
            class="far fa-info-circle"></i> Info
          </button>
        </label>

        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">$</span>
              </div>
              <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioAchat.tauxInteretAnnuel"
                aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
                name="taux_interet_annuel"
                step="1"
                type="number">
              <div class="input-group-append">
                <span class="input-group-text">.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: TAUX D'INTÉRÊT ANNUEL -->

  </div>

  <div class="row">
    <!-- BEGIN: UTILISATION PRÉVUE PLUS DE 10$ D'ACTIVITÉ COMMERCIALE -->
    <div class="col-12 col-lg-6 mt-3">
      <div class="form-group">
        <div class="custom-control custom-switch">

          <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioAchat.utilisationPrevuePlusDe10PourcentActiviteCommerciale"
            class="custom-control-input"
            id="utilisationPrevuePlusDe10PourcentActiviteCommerciale"
            name="utilisationPrevuePlusDe10PourcentActiviteCommerciale"
            type="checkbox">

          <label class="custom-control-label" for="utilisationPrevuePlusDe10PourcentActiviteCommerciale">Est-ce
            qu'il est prévu que le véhicule soit utilisé à plus de 10% pour des activités commerciales?
            <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
              placement="auto"
              popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
              type="button"><i
            class="far fa-info-circle"></i> Info
          </button>
        </label>

      </div>
    </div>
  </div>
  <!-- END: UTILISATION PRÉVUE PLUS DE 10$ D'ACTIVITÉ COMMERCIALE -->

  <!-- BEGIN: MONTANT EMPRUNTÉ SI AUCUNE RENONCIATION À LA SUBVENTION FÉDÉRALE -->
  <div class="col-12 col-lg-6">

    <div class="form-group">

      <label class="mb-1">Montant emprunté si aucune renonciation à la subvention fédérale
        <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
          placement="auto"
          popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
          type="button"><i
        class="far fa-info-circle"></i> Info
      </button>
    </label>

    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioAchat.montantEmprunteSiAucuneRenonciationSubventionFederale"
            aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
            name="montantEmprunteSiAucuneRenonciationSubventionFederale"
            step="1"
            type="number">
          <div class="input-group-append">
            <span class="input-group-text">.00</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- END: MONTANT EMPRUNTÉ SI AUCUNE RENONCIATION À LA SUBVENTION FÉDÉRALE -->
</div>

</div>
</div>
</div>
</div>
<!-- END: SCÉNARIO ACHAT -->

<!-- BEGIN: SCÉNARIO LOCATION-ACHAT -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div (click)="toggleScenarioCollapse('location_achat')" class="card-header card-header-collapsible">
        <div>
          <button class="btn btn-link d-inline ml-0 pl-0">
            @if (isScenarioCollapsed('location_achat') === false) {
              <span>
                <i class="fas fa-chevron-down"></i>
              </span>
            }
            @if (isScenarioCollapsed('location_achat')) {
              <span>
                <i class="fas fa-chevron-right"></i>
              </span>
            }
          </button>

          <h4 class="card-header-title mr-auto d-inline">
            Location d'un véhicule puis rachat du véhicule
          </h4>
        </div>
      </div>

      <div [ngClass]="getScenarioStyle('location_achat')" class="card-body">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group">

              <label class="mb-1">Après combien de mois se termine la première location?
                <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                  placement="auto"
                  popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                  type="button"><i
                class="far fa-info-circle"></i> Info
              </button>
            </label>

            <div class="row">
              <div class="col-12 col-lg-6">
                <div class="input-group">

                  <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioLocationRachat.nombreDeMoisLocation"
                    aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
                    name="nombreDeMoisPremiereLocation"
                    step="1"
                    type="number">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="form-group">

            <label class="mb-1">Quel est le coût de rachat du véhicule?
              <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                placement="auto"
                popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                type="button"><i
              class="far fa-info-circle"></i> Info
            </button>
          </label>

          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <input [(ngModel)]="calculAchatCorporatifAvecAvantage.scenarioLocationRachat.coutRachat"
                  aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
                  name="coutRachat" step="1"
                  type="number">
                <div class="input-group-append">
                  <span class="input-group-text">.00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
<!-- END: SCÉNARIO LOCATION-ACHAT -->

<div class="row">
  <div class="col-12 col-lg-6">
  </div>
</div>

<!-- BEGIN: SUBVENTIONS GOUVERNEMENTALES -->
<hr class="mt-2 mb-5">

<h2>Subventions gouvernementales</h2>

<div class="row">
  <div class="col-12 col-lg-6">

    <div class="form-group">

      <label class="mb-1">Montant de la subvention provinciale
        <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
          placement="auto"
          popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
          type="button"><i
        class="far fa-info-circle"></i> Info
      </button>
    </label>

    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input [(ngModel)]="calculAchatCorporatifAvecAvantage.montantSubventionProvinciale"
            aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
            name="montantSubventionProvinciale" step="1"
            type="number">
          <div class="input-group-append">
            <span class="input-group-text">.00</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="col-12 col-lg-6">

  <div class="form-group">

    <label class="mb-1">Montant de la subvention fédérale
      <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
        placement="auto"
        popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
        type="button"><i
      class="far fa-info-circle"></i> Info
    </button>
  </label>

  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
        <input [(ngModel)]="this.calculAchatCorporatifAvecAvantage.montantSubventionFederale"
          aria-label="Amount (to the nearest dollar)" class="form-control" min="0"
          name="montantSubventionFederale" step="1"
          type="number">
        <div class="input-group-append">
          <span class="input-group-text">.00</span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>

<!-- END: SUBVENTIONS GOUVERNEMENTALES -->

<hr class="mt-2 mb-5">

<h2>Informations annuelles</h2>

<div class="row">
  <div class="col-12">

    <div class="list-group list-group-flush list-group-activity my-n3">
      @for (yearItem of this.calculAchatCorporatifAvecAvantage.years; track yearItem) {
        <div class="list-group-item">
          <div class="row">
            <div class="col-auto">
              <!-- Avatar -->
              <div class="avatar avatar-sm">
                <div class="avatar-title font-size-lg bg-primary-soft rounded-circle text-primary">
                  <small>{{ yearItem.year }}</small>
                </div>
              </div>
            </div>
            <div class="col ml-n2">
              <div class="card">
                <div (click)="toggleYearCardCollapse(yearItem.year)" class="card-header card-header-collapsible">
                  <div>
                    <button class="btn btn-link d-inline ml-0 pl-0">
                      @if (isYearCardCollapsed(yearItem.year) === false) {
                        <span>
                          <i class="fas fa-chevron-down"></i>
                        </span>
                      }
                      @if (isYearCardCollapsed(yearItem.year)) {
                        <span>
                          <i class="fas fa-chevron-right"></i>
                        </span>
                      }
                    </button>
                    <h4 class="card-header-title mr-auto d-inline">
                      Année {{ yearItem.year }}
                    </h4>
                  </div>
                  <ul class="nav nav-tabs nav-tabs-sm card-header-tabs">
                    @if (yearItem.year === this.getLastYear()) {
                      <button (click)="removeLastYear()"
                        class="btn btn-sm btn-outline-danger"
                        type="button">Supprimer cette année
                      </button>
                    }
                  </ul>
                </div>
                <div [ngClass]="getYearCardStyle(yearItem.year)" class="card-body">
                  <h3>Informations sur la société</h3>
                  <div class="row">
                    <div class="col-12 col-lg-6">
                      <div class="form-group">
                        <label class="mb-1">Taux d'imposition de la société
                          <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                            placement="auto"
                            popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                            type="button"><i
                          class="far fa-info-circle"></i> Info
                        </button>
                      </label>
                      <div class="row">
                        <div class="col-12 col-lg-8">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">%</span>
                            </div>
                            <input [(ngModel)]="yearItem.tauxImpositionSociete"
                              [name]="'tauxImpositionSociete' + yearItem.year"
                              aria-label="Amount (to the nearest dollar)" class="form-control" max="100"
                              min="0"
                              step="1"
                              type="number">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                  <h3>Informations sur l'employé</h3>
                  <div class="row">
                    <div class="col-12 col-lg-6">
                      <div class="form-group">
                        <label class="mb-1">Revenu imposable du particulier
                          <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                            placement="auto"
                            popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                            type="button"><i
                          class="far fa-info-circle"></i> Info
                        </button>
                      </label>
                      <div class="row">
                        <div class="col-12 col-lg-8">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input [(ngModel)]="yearItem.revenuAnnuelTotalDuParticulier"
                              [name]="'revenuAnnuelTotalDuParticulier' + yearItem.year"
                              aria-label="Amount (to the nearest dollar)" class="form-control"
                              min="0"
                              step="1"
                              type="number">
                            <div class="input-group-append">
                              <span class="input-group-text">.00</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label class="mb-1">Salaire annuel du particulier
                        <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                          placement="auto"
                          popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                          type="button"><i
                        class="far fa-info-circle"></i> Info
                      </button>
                    </label>
                    <div class="row">
                      <div class="col-12 col-lg-8">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input [(ngModel)]="yearItem.salaireAnnuelDuParticulier"
                            [name]="'salaireAnnuelDuParticulier_' + yearItem.year"
                            aria-label="Amount (to the nearest dollar)" class="form-control"
                            min="0"
                            step="1"
                            type="number">
                          <div class="input-group-append">
                            <span class="input-group-text">.00</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="form-group">
                    <label class="mb-1">Avantage imposable reliée au stationnement
                      <button class="btn btn-link" ngbPopover="Entrez le montant précis en incluant les taxes"
                        placement="auto"
                        popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                        type="button"><i
                      class="far fa-info-circle"></i> Info
                    </button>
                  </label>
                  <div class="row">
                    <div class="col-12 col-lg-8">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">$</span>
                        </div>
                        <input [(ngModel)]="yearItem.avantageImposableStationnement"
                          [name]="'avantageImposableStationnement_' + yearItem.year"
                          aria-label="Amount (to the nearest dollar)" class="form-control"
                          min="0"
                          step="1"
                          type="number">
                        <div class="input-group-append">
                          <span class="input-group-text">.00</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
              <h3>Frais annuels du véhicule</h3>
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="form-group">
                    <label class="mb-1">Coût du permis de conduire
                      <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
                        placement="auto"
                        popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                        type="button"><i
                      class="far fa-info-circle"></i> Info
                    </button>
                  </label>
                  <div class="row">
                    <div class="col-12 col-lg-8">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">$</span>
                        </div>
                        <input [(ngModel)]="yearItem.coutPermisConduire"
                          [name]="'cout_permis_conduire_' + yearItem.year"
                          aria-label="Amount (to the nearest dollar)" class="form-control"
                          min="0"
                          step="1"
                          type="number">
                        <div class="input-group-append">
                          <span class="input-group-text">.00</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label class="mb-1">Coût de l'immatriculation
                    <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
                      placement="auto"
                      popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                      type="button"><i
                    class="far fa-info-circle"></i> Info
                  </button>
                </label>
                <div class="row">
                  <div class="col-12 col-lg-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                      </div>
                      <input [(ngModel)]="yearItem.coutImmatriculation"
                        [name]="'cout_immatriculation_' + yearItem.year"
                        aria-label="Amount (to the nearest dollar)" class="form-control"
                        min="0"
                        step="1"
                        type="number">
                      <div class="input-group-append">
                        <span class="input-group-text">.00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="mb-1">Coût de l'essence (avec taxes)
                  <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
                    placement="auto"
                    popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                    type="button"><i
                  class="far fa-info-circle"></i> Info
                </button>
              </label>
              <div class="row">
                <div class="col-12 col-lg-8">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                    <input [(ngModel)]="yearItem.coutEssenceAvecTaxes"
                      [name]="'cout_essence_avec_taxes_' + yearItem.year"
                      aria-label="Amount (to the nearest dollar)" class="form-control"
                      min="0"
                      step="1"
                      type="number">
                    <div class="input-group-append">
                      <span class="input-group-text">.00</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label class="mb-1">Coût de l'électricité (sans taxes)
                <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
                  placement="auto"
                  popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                  type="button"><i
                class="far fa-info-circle"></i> Info
              </button>
            </label>
            <div class="row">
              <div class="col-12 col-lg-8">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input [(ngModel)]="yearItem.coutElectriciteSansTaxes"
                    [name]="'cout_electricite_sans_taxes_' + yearItem.year"
                    aria-label="Amount (to the nearest dollar)" class="form-control"
                    min="0"
                    step="1"
                    type="number">
                  <div class="input-group-append">
                    <span class="input-group-text">.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label class="mb-1">Coût du stationnement
              <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
                placement="auto"
                popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                type="button"><i
              class="far fa-info-circle"></i> Info
            </button>
          </label>
          <div class="row">
            <div class="col-12 col-lg-8">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <input [(ngModel)]="yearItem.coutStationnement"
                  [name]="'coutStationnement_' + yearItem.year"
                  aria-label="Amount (to the nearest dollar)" class="form-control"
                  min="0"
                  step="1"
                  type="number">
                <div class="input-group-append">
                  <span class="input-group-text">.00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
      <h3>Utilisation annuelle du véhicule</h3>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label class="mb-1">Nombre de kilomètres totaux parcouru par année
              <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
                placement="auto"
                popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                type="button"><i
              class="far fa-info-circle"></i> Info
            </button>
          </label>
          <div class="row">
            <div class="col-12 col-lg-8">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <input [(ngModel)]="yearItem.nombreDeKilometresTotauxParcouruParAnnee"
                  [name]="'nombre_de_kilometres_totaux_parcouru_par_annee_' + yearItem.year"
                  aria-label="Amount (to the nearest dollar)" class="form-control"
                  min="0"
                  step="1"
                  type="number">
                <div class="input-group-append">
                  <span class="input-group-text">.00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label class="mb-1">Nombre de kilomètres totaux parcouru pour affaire par année
            <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
              placement="auto"
              popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
              type="button"><i
            class="far fa-info-circle"></i> Info
          </button>
        </label>
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">$</span>
              </div>
              <input [(ngModel)]="yearItem.nombreDeKilometresParcouruPourAffaireParAnnee"
                [name]="'nombre_de_kilometres_parcouru_pour_affaire_par_annee_' + yearItem.year"
                aria-label="Amount (to the nearest dollar)" class="form-control"
                min="0"
                step="1"
                type="number">
              <div class="input-group-append">
                <span class="input-group-text">.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr>
    <h3>Données spécifiques à la location</h3>
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label class="mb-1">Coût annuel de l'assurance (avec taxes)
            <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
              placement="auto"
              popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
              type="button"><i
            class="far fa-info-circle"></i> Info
          </button>
        </label>
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">$</span>
              </div>
              <input [(ngModel)]="yearItem.coutAssuranceLocationAvecTaxes"
                [name]="'coutAssuranceLocationAvecTaxes' + yearItem.year"
                aria-label="Amount (to the nearest dollar)" class="form-control"
                min="0"
                step="1"
                type="number">
              <div class="input-group-append">
                <span class="input-group-text">.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="form-group">
        <label class="mb-1">Montant de l'entretien et des réparations (avec taxes)
          <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
            placement="auto"
            popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
            type="button"><i
          class="far fa-info-circle"></i> Info
        </button>
      </label>
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">$</span>
            </div>
            <input [(ngModel)]="yearItem.coutEntretienReparationLocationAvecTaxes"
              [name]="'coutEntretienReparationLocationAvecTaxes' + yearItem.year"
              aria-label="Amount (to the nearest dollar)" class="form-control"
              min="0"
              step="1"
              type="number">
            <div class="input-group-append">
              <span class="input-group-text">.00</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<hr>
  <h3>Données spécifiques à l'achat</h3>
  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="form-group">
        <label class="mb-1">Coût annuel de l'assurance (avec taxes)
          <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
            placement="auto"
            popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
            type="button"><i
          class="far fa-info-circle"></i> Info
        </button>
      </label>
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">$</span>
            </div>
            <input [(ngModel)]="yearItem.coutAssuranceAchatAvecTaxes"
              [name]="'coutAssuranceAchatAvecTaxes' + yearItem.year"
              aria-label="Amount (to the nearest dollar)" class="form-control"
              min="0"
              step="1"
              type="number">
            <div class="input-group-append">
              <span class="input-group-text">.00</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-6">
    <div class="form-group">
      <label class="mb-1">Montant de l'entretien et des réparations (avec taxes)
        <button class="btn btn-link" ngbPopover="Entrez le montant exacte avec les taxes"
          placement="auto"
          popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
          type="button"><i
        class="far fa-info-circle"></i> Info
      </button>
    </label>
    <div class="row">
      <div class="col-12 col-lg-8">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input [(ngModel)]="yearItem.coutEntretienReparationAchatAvecTaxes"
            [name]="'coutEntretienReparationAchatAvecTaxes' + yearItem.year"
            aria-label="Amount (to the nearest dollar)" class="form-control"
            min="0"
            step="1"
            type="number">
          <div class="input-group-append">
            <span class="input-group-text">.00</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
@if (yearItem.year === this.getLastYear()) {
  <div>
    <hr>
      <h3>Fin du calcul</h3>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label class="mb-1">À quel mois se termine le calcul?
              <button class="btn btn-link"
                ngbPopover="Entrez le montant précis en incluant les taxes"
                placement="auto"
                popoverTitle="Montant de l'entretien et réparation pour l'achat (sans taxes) "
                type="button"><i
              class="far fa-info-circle"></i> Info
            </button>
          </label>
          <div class="row">
            <div class="col-12 col-lg-6">
              <select [(ngModel)]="yearItem.moisAPartirDuquelOnTermineLesCalculs"
                [name]="'moisAPartirDuquelOnTermineLesCalculs_' + yearItem.year"
                class="custom-select"
                data-toggle="select">
                <option [ngValue]="1">Janvier</option>
                <option [ngValue]="2">Février</option>
                <option [ngValue]="3">Mars</option>
                <option [ngValue]="4">Avril</option>
                <option [ngValue]="5">Mai</option>
                <option [ngValue]="6">Juin</option>
                <option [ngValue]="7">Juillet</option>
                <option [ngValue]="8">Août</option>
                <option [ngValue]="9">Septembre</option>
                <option [ngValue]="10">Octobre</option>
                <option [ngValue]="11">Novembre</option>
                <option [ngValue]="12">Décembre</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>
</div>
</div>
</div> <!-- / .row -->
</div>
}
<div class="list-group-item">
  <div class="row">
    <div class="col-auto">

      <!-- Avatar -->
      <div class="avatar avatar-sm">
        <div class="avatar-title font-size-lg bg-primary-soft rounded-circle text-primary">
          <i class="fad fa-plus-circle"></i>
        </div>
      </div>

    </div>
    <div class="col ml-n2">

      <!-- Heading -->
      <button (click)="addYear()" class="btn btn-light">
        Ajouter une année
      </button>
    </div>
  </div> <!-- / .row -->
</div>
</div>
</div>
</div>

<hr class="mt-5 mb-5">

<div class="row">
  <div class="col-12 mt-2">
    <div class="card">
      <div class="card-header">
        <h2 class="card-header-title mr-auto d-inline">
          Résumé du calcul
        </h2>
      </div>
      <div class="card-body">
        <p>Début du calcul: <strong>{{ this.getFirstYear() }}
        -{{ this.calculAchatCorporatifAvecAvantage.moisVehiculeMisADispositionPourEmployee }}</strong></p>
        <p>Fin du calcul: <strong>{{ this.getLastYear() }}
        -{{ this.getLastYearObject().moisAPartirDuquelOnTermineLesCalculs }}</strong></p>
        <p>Nombre de mois inclus dans le calcul: <strong>{{ this.getNumberOfMonthsInCalculation() }}
        mois</strong>
      </p>
    </div>
  </div>
</div>
</div>

<div class="row">
  <div class="col-12 mt-3">
    <button class="btn btn-primary btn-lg btn-block" type="button">Rouler le calcul</button>
  </div>
</div>

</form>
</div>

</div>
</div>


<div class="container">
  <div class="row">
    <pre>{{ this.calculAchatCorporatifAvecAvantage | json }}</pre>
  </div>
</div>
